import { render, staticRenderFns } from "./Led.vue?vue&type=template&id=58357046&"
import script from "./Led.vue?vue&type=script&lang=js&"
export * from "./Led.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports